export interface Movie {
  id: string;
  title: string;
  cover: string;
  category: 'traditional' | 'modern' | 'film';
  categoryLabel: string;
  genre: string;
  year: number;
  director: string;
  cast: string[];
  summary: string;
  plot: string[];
  views: number;
  rating: number;
  status: string;
}

export const movieCategories = [
  {
    key: 'traditional',
    label: '传统伦理剧',
    desc: '以家族、孝道、宗族礼法为核心的经典韩国伦理剧，探讨血脉与责任之间的拉扯。',
    image: 'https://readdy.ai/api/search-image?query=traditional%20Korean%20hanok%20courtyard%20at%20dusk%20with%20warm%20lantern%20light%20and%20stone%20walls%2C%20cinematic%20moody%20atmosphere%2C%20muted%20deep%20blue%20and%20warm%20gray%20palette%2C%20elegant%20editorial%20photography&width=800&height=600&seq=kr-ethics-cat-traditional&orientation=landscape',
  },
  {
    key: 'modern',
    label: '现代伦理剧',
    desc: '聚焦都市家庭、婚姻与代际冲突的当代韩国伦理剧，直击现实生活中的道德困境。',
    image: 'https://readdy.ai/api/search-image?query=modern%20Seoul%20apartment%20window%20at%20blue%20hour%20with%20city%20lights%20bokeh%2C%20quiet%20melancholic%20mood%2C%20muted%20deep%20blue%20and%20warm%20gray%20palette%2C%20refined%20cinematic%20photography%2C%20no%20people&width=800&height=600&seq=kr-ethics-cat-modern&orientation=landscape',
  },
  {
    key: 'film',
    label: '伦理电影',
    desc: '以电影语言细腻描绘人性与伦理的韩国伦理电影，节奏克制，余韵悠长。',
    image: 'https://readdy.ai/api/search-image?query=empty%20Korean%20cinema%20theater%20seats%20with%20soft%20projector%20light%20beam%2C%20moody%20dramatic%20atmosphere%2C%20muted%20deep%20blue%20and%20warm%20gray%20tones%2C%20editorial%20cinematography%2C%20no%20people&width=800&height=600&seq=kr-ethics-cat-film&orientation=landscape',
  },
];

export const heroSlides = [
  {
    id: 'slide-1',
    tag: '经典伦理剧推荐',
    title: '家族的重量',
    subtitle: '当血脉成为枷锁，谁来为沉默的一代发声',
    desc: '从韩屋深院到现代都市，八部经典伦理剧带你走进韩国社会的家庭伦理深处。',
    category: 'traditional',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20dark%20moody%20traditional%20Korean%20hanok%20courtyard%20at%20night%20with%20soft%20warm%20light%20from%20paper%20lanterns%2C%20deep%20shadows%20and%20calm%20atmosphere%2C%20muted%20deep%20blue%20and%20warm%20gray%20palette%2C%20wide%20editorial%20composition%2C%20no%20people%2C%20space%20for%20text&width=1920&height=900&seq=kr-ethics-hero-1&orientation=landscape',
  },
  {
    id: 'slide-2',
    tag: '现代伦理大赏',
    title: '城市里的裂缝',
    subtitle: '婚姻、亲情与选择，现代都市的伦理现场',
    desc: '精选十部当代伦理剧与电影，以克制镜头记录都市人无法言说的道德困境。',
    category: 'modern',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20modern%20Seoul%20skyline%20at%20blue%20hour%20with%20reflective%20windows%20and%20calm%20misty%20sky%2C%20muted%20deep%20blue%20tones%2C%20elegant%20wide%20editorial%20composition%2C%20no%20people%2C%20space%20for%20text&width=1920&height=900&seq=kr-ethics-hero-2&orientation=landscape',
  },
  {
    id: 'slide-3',
    tag: '伦理电影专辑',
    title: '沉默的季节',
    subtitle: '用两小时的安静，讲一个说不出口的故事',
    desc: '聚焦人性底色的韩国伦理电影专题，慢节奏、强余韵，适合深夜独自观看。',
    category: 'film',
    image: 'https://readdy.ai/api/search-image?query=abstract%20cinematic%20scene%20of%20a%20lone%20window%20with%20rain%20streaks%20and%20soft%20warm%20interior%20glow%2C%20moody%20restrained%20atmosphere%2C%20muted%20deep%20blue%20and%20charcoal%20palette%2C%20wide%20editorial%20composition%2C%20no%20people%2C%20space%20for%20text&width=1920&height=900&seq=kr-ethics-hero-3&orientation=landscape',
  },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '家族的阴影',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20family%20drama%20key%20art%20poster%2C%20dim%20traditional%20hanok%20room%20with%20a%20single%20wooden%20table%20and%20warm%20lamp%2C%20solemn%20melancholic%20mood%2C%20muted%20deep%20blue%20and%20warm%20gray%20palette%2C%20film%20grain%2C%20space%20for%20title%20text&width=600&height=900&seq=kr-ethics-poster-01&orientation=portrait',
    category: 'traditional',
    categoryLabel: '传统伦理剧',
    genre: '家庭',
    year: 2019,
    director: '朴正勋',
    cast: ['金敏贞', '李书妍', '崔正宇', '韩志浩'],
    summary: '长子继承的不仅是家业，还有一段被全家默许掩盖的往事。',
    plot: [
      '金氏家族世代经营着一座位于庆州的韩屋老宅，长子金泰周在父亲骤然离世后，被迫放弃首尔的事业回到故乡，接过看似光鲜的家业。表面上，这是一场体面的继承，实则每一块梁木下都压着一段无人愿意提起的秘密。',
      '随着整理父亲遗物，泰周发现一本被反复涂改的账册，牵出二十年前一桩被家族合力掩盖的旧事。母亲与二叔口径一致地劝他"不必深究"，而妹妹惠珍则坚持要一个真相。原本和睦的家族在饭桌前一次次沉默，又一次次爆发。',
      '当真相最终浮出水面，泰周才明白，所谓孝道与体面，有时不过是成年人为自己找的借口。他必须在维护家族名誉与还原历史之间做出选择，而这个选择，将决定这个家族是否还有愈合的可能。',
    ],
    views: 48200,
    rating: 8.7,
    status: '已完结',
  },
  {
    id: '2',
    title: '归乡',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20traditional%20drama%20poster%2C%20rural%20village%20road%20at%20dusk%20with%20mist%20and%20a%20distant%20lone%20figure%20silhouette%2C%20nostalgic%20quiet%20mood%2C%20muted%20deep%20blue%20and%20warm%20gray%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-02&orientation=portrait',
    category: 'traditional',
    categoryLabel: '传统伦理剧',
    genre: '亲情',
    year: 2016,
    director: '郑雅拉',
    cast: ['宋在赫', '孙美京', '吴世勋'],
    summary: '离开故乡二十年的儿子，回来时只剩下一个无法送出的道歉。',
    plot: [
      '二十年前，成浩为了逃离父亲安排的人生，在一个清晨不辞而别。二十年后，他带着城市里积攒的疲惫与一副失败者的姿态回到故乡，却发现记忆中那座一切如旧的老屋早已被时间改写。',
      '母亲的记忆正在一点点消散，她时而认得他，时而又把他当作陌生人。父亲已经过世三年，墓碑上刻着的名字让成浩第一次意识到，有些告别永远来得太晚。村里人用沉默议论他，而唯一愿意开口的，是当年替他保守秘密的老邻居。',
      '在陪伴母亲最后的这段日子里，成浩开始重新学习"回家"这件事。他修好漏雨的屋顶、重新种下母亲最爱的花，也终于读懂了父亲当年未曾说出口的期望。归乡不是回到起点，而是学会与过去和解。',
    ],
    views: 35800,
    rating: 8.4,
    status: '已完结',
  },
  {
    id: '3',
    title: '母亲的契约',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20mother%20and%20child%20drama%20poster%2C%20soft%20warm%20window%20light%20on%20empty%20dining%20table%20with%20folded%20letter%2C%20emotional%20restrained%20mood%2C%20muted%20deep%20blue%20and%20beige%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-03&orientation=portrait',
    category: 'traditional',
    categoryLabel: '传统伦理剧',
    genre: '家庭',
    year: 2021,
    director: '朴正勋',
    cast: ['白恩静', '李道贤', '金所泫'],
    summary: '一份写在纸上的"契约"，捆住了三个孩子的整个人生。',
    plot: [
      '母亲姜女士在丈夫去世后，立下一份看似公平的"家族契约"：三个子女必须轮流赡养她，每人一年，谁违反约定就放弃继承权。这份协议像一根看不见的绳子，把早已各自生活多年的兄妹三人重新绑回同一屋檐下。',
      '大儿子忙于事业，把照顾母亲当作例行公事；二女儿温柔细致，却在日复一日的付出中渐渐心生怨怼；小儿子看似最孝顺，实则另有所图。母亲的房间成了三人暗中较劲的战场，饭菜的咸淡、开窗的时间，都成了无声的较量。',
      '直到母亲病重，医生说出那个所有人都不愿面对的诊断，兄妹三人才发现，这份契约真正的用意从来不是分配财产，而是让彼此还能有一个理由坐在一起。所谓伦理，有时正是爱在规则里笨拙的伪装。',
    ],
    views: 52600,
    rating: 8.9,
    status: '已完结',
  },
  {
    id: '4',
    title: '长子的责任',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20traditional%20family%20drama%20poster%2C%20formal%20ancestral%20ritual%20table%20with%20incense%20smoke%20in%20dim%20room%2C%20solemn%20dignified%20mood%2C%20muted%20deep%20blue%20and%20warm%20brown%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-04&orientation=portrait',
    category: 'traditional',
    categoryLabel: '传统伦理剧',
    genre: '家庭',
    year: 2014,
    director: '崔承宇',
    cast: ['张东健', '金喜爱', '刘亚仁'],
    summary: '被"长子"两个字束缚的一生，究竟是谁规定他必须牺牲。',
    plot: [
      '在金氏宗族里，长子意味着一切：祭祀由他主持，债务由他承担，弟妹的前途由他垫付。哥哥民俊从大学毕业那天起，就把自己的人生上交给了这个身份。他放弃了出国的机会、推迟了婚事，只为让弟弟妹妹们能走得更远。',
      '然而当年迈的父亲卧病在床，弟弟却在国外迟迟不归，妹妹把一切推给"大哥应该有办法"。民俊第一次在祭桌前质问自己：这份责任究竟是传统的美德，还是家族默认的剥削。他的妻子也终于忍无可忍，要求他在家族和小家庭之间选一个。',
      '一场关于房产与赡养的家族会议，把所有人的真面目摊在桌上。民俊在争执中第一次为自己发声，也在长辈的沉默里明白，传统从来不是一成不变的教条，而是需要每一代人重新商量、重新定义的约定。',
    ],
    views: 29300,
    rating: 8.1,
    status: '已完结',
  },
  {
    id: '5',
    title: '沉默的孝',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20elderly%20care%20drama%20poster%2C%20quiet%20hospital%20corridor%20with%20soft%20afternoon%20light%20and%20empty%20wheelchair%2C%20wistful%20melancholic%20mood%2C%20muted%20deep%20blue%20and%20warm%20gray%20palette%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-05&orientation=portrait',
    category: 'traditional',
    categoryLabel: '传统伦理剧',
    genre: '亲情',
    year: 2018,
    director: '郑雅拉',
    cast: ['尹汝贞', '薛景求', '金泰梨'],
    summary: '当尽孝变成一场按时打卡的任务，爱还剩下多少。',
    plot: [
      '退休教师赵女士独自住在首尔近郊的小楼里，三个子女分布在三座城市。他们每个月按时转账生活费、每季度轮流探望一次，把"孝"活成了一项完成度很高的KPI。赵女士从不抱怨，只在深夜把电视声音开得很小。',
      '一次意外摔倒后，赵女士被迫搬去和最小的女儿同住。生活习惯的冲突、代际观念的摩擦，让原本客气的母女关系迅速紧绷。女儿发现，母亲藏了整整一柜子的旧信和药盒，那些从未被翻开的往事，比她想象中沉重得多。',
      '在照顾母亲的日子里，女儿渐渐读懂了她那些欲言又止的沉默。原来"孝"最难的部分，不是提供多少物质，而是愿意停下来，听一个老人把话说完。这部剧温柔而锋利地追问：我们究竟是在赡养父母，还是在偿还自己的愧疚。',
    ],
    views: 41100,
    rating: 8.6,
    status: '已完结',
  },
  {
    id: '6',
    title: '城市边缘',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20modern%20Korean%20urban%20drama%20poster%2C%20rainy%20city%20street%20at%20night%20with%20neon%20reflections%20and%20lone%20umbrella%2C%20lonely%20restrained%20mood%2C%20muted%20deep%20blue%20and%20warm%20gray%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-06&orientation=portrait',
    category: 'modern',
    categoryLabel: '现代伦理剧',
    genre: '都市',
    year: 2022,
    director: '李知恩',
    cast: ['玄彬', '裴秀智', '李圣经'],
    summary: '在一座不属于自己的城市里，每个人都在替别人活着。',
    plot: [
      '在首尔打拼的四个年轻人合租在一栋老旧的公寓里，他们来自不同的地方，却有着相似的疲惫：为了房租、工作和家里的期待，把真实的自己一层层藏起来。表面上，他们是最体面的"首尔人"。',
      '一场意外的经济纠纷让四人的关系彻底失衡，钱、谎言与善意的隐瞒交织在一起。有人为了家中的债务铤而走险，有人为了留在城市隐瞒自己的婚史，还有人一直在替别人照顾一个并不属于自己的孩子。',
      '当他们终于不得不面对彼此，才发现所谓都市伦理的困境，从来不是非黑即白的选择题，而是每个人都以为自己在为别人好的时候，悄悄伤害了最近的人。剧集以细腻的群像，描摹出当代年轻人无处安放的道德焦虑。',
    ],
    views: 67900,
    rating: 8.8,
    status: '已完结',
  },
  {
    id: '7',
    title: '双重生活',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20modern%20Korean%20marriage%20drama%20poster%2C%20two%20overlapping%20doorways%20in%20a%20dim%20apartment%20corridor%2C%20tense%20secretive%20mood%2C%20muted%20deep%20blue%20and%20cool%20gray%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-07&orientation=portrait',
    category: 'modern',
    categoryLabel: '现代伦理剧',
    genre: '婚姻',
    year: 2023,
    director: '李知恩',
    cast: ['金泰希', '河正宇', '千玗嬉'],
    summary: '一个男人在两个家庭之间来回穿梭，直到谎言再也无法折叠。',
    plot: [
      '建筑事务所的合伙人正民事业有成、家庭美满，是外人眼中的模范丈夫。没人知道，他在城市的另一端还有另一个家，一段他从未打算让任何人知道的过往，正在一点点耗尽他的心。',
      '两个女人各自以为自己是唯一的那个，直到一次偶然的社群照片，让两条平行线骤然相交。愤怒、羞辱与被欺骗的痛楚之下，是更复杂的现实：他们都曾在这段关系中付出真心，也都在这段关系中失去了自己。',
      '剧集没有简单地审判谁对谁错，而是缓缓展开每个人设下谎言的动机。当正民必须做出选择时，观众要面对的问题变得尖锐：一个由谎言支撑的完整家庭，和一个由真相构成的破碎家庭，哪一个更接近"伦理"。',
    ],
    views: 73400,
    rating: 8.5,
    status: '已完结',
  },
  {
    id: '8',
    title: '离婚律师',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20legal%20drama%20poster%2C%20stack%20of%20documents%20on%20a%20desk%20with%20a%20glass%20of%20water%20and%20soft%20window%20light%2C%20serious%20reflective%20mood%2C%20muted%20deep%20blue%20and%20warm%20gray%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-08&orientation=portrait',
    category: 'modern',
    categoryLabel: '现代伦理剧',
    genre: '都市',
    year: 2020,
    director: '崔承宇',
    cast: ['李政宰', '全度妍', '金高银'],
    summary: '专打离婚官司的律师，却在自己的婚姻里束手无策。',
    plot: [
      '律师事务所的合伙人文洙专攻离婚案件，十几年来他见过太多婚姻的崩塌，也因此对感情保持着冷静到近乎冷漠的距离。他坚信婚姻只是需要被妥善管理的合同。',
      '直到妻子平静地递上一份离婚协议，他才发现自己早已被同样的逻辑困住——他从未真正听妻子说过话，也从未意识到那些被他视为"没事"的沉默，是日积月累的失望。他开始用打官司的思维去挽回婚姻，却一次次弄巧成拙。',
      '剧集借由一个个真实的离婚案件，把婚姻里的伦理难题摊在观众面前：付出与被看见、责任与自由、原谅与底线。文洙最终明白，感情不是可以计算输赢的案子，而是一场需要两个人共同承认脆弱的修行。',
    ],
    views: 58200,
    rating: 8.3,
    status: '已完结',
  },
  {
    id: '9',
    title: '公寓的秘密',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20mystery%20family%20drama%20poster%2C%20dim%20apartment%20hallway%20with%20one%20slightly%20open%20door%20and%20faint%20light%2C%20uneasy%20secretive%20mood%2C%20muted%20deep%20blue%20and%20cool%20gray%20palette%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-09&orientation=portrait',
    category: 'modern',
    categoryLabel: '现代伦理剧',
    genre: '悬疑',
    year: 2021,
    director: '郑雅拉',
    cast: ['孙艺珍', '赵寅成', '金泰梨'],
    summary: '搬进新家的那一刻，邻居们的善意里藏着太多问题。',
    plot: [
      '带着女儿搬进老旧公寓的母亲英恩，只想开始一段安静的新生活。然而从第一天起，邻居们过分热情的关心就让她感到不安：有人主动接送孩子，有人频繁借故上门，还有人似乎对她的过去知道得太多。',
      '一次停电的夜晚，英恩在楼道里发现了一个关于这栋楼的传闻——上一户住在这里的家庭曾在一场无人提及的意外中离开。随着她一步步接近真相，邻居们善意的面具开始出现裂缝，每个人都在维护着什么。',
      '这部剧以悬疑的外壳包裹伦理的内核，探讨集体沉默的代价。当整个社区选择对一件事视而不见，究竟是在保护谁，又是在伤害谁。英恩的追问，最终也逼视向观众内心那个"多一事不如少一事"的自己。',
    ],
    views: 49500,
    rating: 8.2,
    status: '已完结',
  },
  {
    id: '10',
    title: '血缘之外',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20adoption%20family%20drama%20poster%2C%20pair%20of%20small%20children%20shoes%20by%20a%20warm%20front%20door%2C%20tender%20bittersweet%20mood%2C%20muted%20deep%20blue%20and%20warm%20beige%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-10&orientation=portrait',
    category: 'modern',
    categoryLabel: '现代伦理剧',
    genre: '亲情',
    year: 2024,
    director: '李知恩',
    cast: ['金惠子', '李到晛', '朴恩斌'],
    summary: '没有血缘的母子，用十年时间证明什么叫真正的家。',
    plot: [
      '独居的老太太玉子在一场事故后收养了失去双亲的少年时厚。两个人没有任何血缘关系，甚至连性格都格格不入，却在同一个屋檐下磕磕绊绊地开始了彼此的人生。',
      '随着时厚长大，生父那边的亲戚忽然出现，以血缘为由要求接走孩子。法律、情感与旁人的议论一起涌来，玉子第一次意识到，自己用了十年的陪伴，在别人眼里竟比不上一纸血缘。',
      '剧集用最朴素的日常细节回答了一个沉重的问题：究竟什么才构成一个"家"。血缘是起点，但爱与责任才是答案。当法律程序与内心归属发生冲突时，这对"非亲非故"的母子必须一起找到属于他们的方式。',
    ],
    views: 61800,
    rating: 9.0,
    status: '已完结',
  },
  {
    id: '11',
    title: '春日告白',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20romantic%20drama%20film%20poster%2C%20cherry%20blossom%20petals%20drifting%20over%20an%20empty%20park%20bench%20in%20soft%20spring%20light%2C%20tender%20bittersweet%20mood%2C%20muted%20warm%20pink%20and%20gray%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-11&orientation=portrait',
    category: 'film',
    categoryLabel: '伦理电影',
    genre: '爱情',
    year: 2019,
    director: '郑雅拉',
    cast: ['朴宝剑', '金泰梨', '刘智泰'],
    summary: '两个各自背负秘密的人，在一个春天里学会了坦白。',
    plot: [
      '在一座小城的图书馆工作的素英，习惯把心事写在便签上夹进书里。来借书的医生志勋无意中读到一张，两个陌生人的命运便从这页纸开始交汇。他们都有一段不愿触碰的过去，也都在春天里小心翼翼地靠近。',
      '素英隐瞒了自己曾是某场医疗纠纷当事人的身份，而志勋则正是当年那家医院的主治医师。两人在彼此都不知道的情况下逐渐走近，真相像春雪一样，迟早在阳光里融化。',
      '电影没有制造戏剧化的对峙，而是安静地记录了两个成年人在道德与情感之间的犹疑。当秘密终于被说出口，春日里的告白不仅是对爱的承认，更是对过往的忏悔与原谅。',
    ],
    views: 32700,
    rating: 8.4,
    status: '已上映',
  },
  {
    id: '12',
    title: '沉默的季节',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20art%20drama%20film%20poster%2C%20frozen%20lake%20surface%20under%20a%20pale%20overcast%20sky%20with%20soft%20mist%2C%20cold%20melancholic%20mood%2C%20muted%20deep%20blue%20and%20steel%20gray%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-12&orientation=portrait',
    category: 'film',
    categoryLabel: '伦理电影',
    genre: '剧情',
    year: 2017,
    director: '崔承宇',
    cast: ['薛景求', '文素利', '刘亚仁'],
    summary: '一个冬天里，沉默比语言更响。',
    plot: [
      '在一座北方小城的冬天，水产工人东哲在一次事故中选择沉默，没有说出真正发生的事。他的沉默保护了工友的饭碗，也让自己背上了无人知晓的愧疚。',
      '他的妻子发现丈夫开始失眠、独坐，甚至逃避孩子的目光。她试图撬开那道紧闭的门，却在一次次碰壁中逐渐明白，东哲保护的不是别人，而是他自己无法面对的那部分良心。',
      '电影以极简的对白和漫长的镜头，呈现一个普通人在道德困境里的孤独。所谓沉默的季节，不是无话可说，而是有些话一旦说出口，生活就再也回不去了。',
    ],
    views: 24600,
    rating: 8.6,
    status: '已上映',
  },
  {
    id: '13',
    title: '海边来信',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20drama%20film%20poster%2C%20quiet%20rocky%20seaside%20with%20gentle%20waves%20and%20a%20lone%20wooden%20postbox%2C%20wistful%20nostalgic%20mood%2C%20muted%20deep%20blue%20and%20warm%20sand%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-13&orientation=portrait',
    category: 'film',
    categoryLabel: '伦理电影',
    genre: '剧情',
    year: 2022,
    director: '朴正勋',
    cast: ['金高银', '李星民', '千玗嬉'],
    summary: '一封迟到三十年的信，让两个家庭重新面对同一个秘密。',
    plot: [
      '经营海边民宿的英淑收到一封没有寄件人的旧信，落款日期是三十年前。信里提到一个名字，那是她从未听母亲提起过的姐姐。从这一刻起，她平静的生活被这封信彻底打乱。',
      '英淑顺着线索找到另一座城市，见到了信中提到的那户人家。原来母亲年轻时曾把一个孩子送给他人抚养，而多年来的沉默，成了两个家庭共同的伤口。认与不认、怨与不怨，没有一种选择是轻松的。',
      '电影用一封来信串起两代人的伦理抉择，克制地探讨亲情中的亏欠与释怀。海边的信终究没有被退回，因为有些话，晚一点到，也比永远不来要好。',
    ],
    views: 38400,
    rating: 8.7,
    status: '已上映',
  },
  {
    id: '14',
    title: '陌生的家人',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20family%20drama%20film%20poster%2C%20dining%20table%20set%20for%20people%20but%20with%20empty%20chairs%20and%20soft%20evening%20light%2C%20quiet%20tense%20mood%2C%20muted%20deep%20blue%20and%20warm%20gray%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-14&orientation=portrait',
    category: 'film',
    categoryLabel: '伦理电影',
    genre: '家庭',
    year: 2020,
    director: '李知恩',
    cast: ['尹汝贞', '薛景求', '金泰梨'],
    summary: '同一张餐桌上，坐着一群最熟悉的陌生人。',
    plot: [
      '一次突如其来的遗产分配，把散落各处、多年不联系的兄弟姐妹召集回老宅。他们曾经在一张餐桌上长大，如今却连彼此的近况都一无所知。',
      '三天的共处里，旧账被一件件翻出：谁当年占了便宜，谁在父母病重时缺席，谁把孩子的教育早早推给了老人。每个人都振振有词，每个人也都心虚。饭菜热了又凉，话越说越伤。',
      '这部电影没有给出和解的答案，只是诚实地记录了血缘关系里那种既亲密又疏离的复杂。所谓"陌生的家人"，或许正是现代人共同的处境——我们共享同一个姓氏，却早已走散在各自的人生里。',
    ],
    views: 31200,
    rating: 8.3,
    status: '已上映',
  },
  {
    id: '15',
    title: '冬夜微光',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20Korean%20winter%20drama%20film%20poster%2C%20warm%20glowing%20window%20light%20on%20a%20snowy%20quiet%20street%20at%20night%2C%20hopeful%20gentle%20mood%2C%20muted%20deep%20blue%20and%20warm%20amber%20tones%2C%20film%20grain%2C%20space%20for%20title&width=600&height=900&seq=kr-ethics-poster-15&orientation=portrait',
    category: 'film',
    categoryLabel: '伦理电影',
    genre: '剧情',
    year: 2023,
    director: '崔承宇',
    cast: ['李到晛', '朴恩斌', '文素利'],
    summary: '在最冷的冬夜，两个陌生的人彼此成为了那一点微光。',
    plot: [
      '在一座小城的冬夜，失业的青年俊浩在便利店值夜班，遇见了一位常来买同一种泡面的中年女人美兰。两人沉默地共享着同一个深夜，谁也没有问对方为什么还不回家。',
      '一次意外让美兰说出自己的处境：她为了照顾患病的丈夫辞去了工作，却在丈夫康复后被要求"别再拖累这个家"。而俊浩也藏着一段无法告诉家人的失败。两个陌生人在便利店的灯光下，第一次把心里的话说了出来。',
      '电影以一个温暖的结尾收束，却并不回避现实的重量。所谓微光，不是把人从黑暗里救出来，而是在最冷的时候，让彼此知道还有人愿意站在旁边。这是关于尊严、善意与微小救赎的伦理故事。',
    ],
    views: 45600,
    rating: 8.8,
    status: '已上映',
  },
];